// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module--link--1ujM_","active":"styles-module--active--pgx4R"};